"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SortableWrapper = void 0;
const react_1 = __importDefault(require("react"));
const sortable_1 = require("@dnd-kit/sortable");
const utilities_1 = require("@dnd-kit/utilities");
const item_wrapper_1 = require("./item-wrapper");
function SortableWrapper(props) {
    const { attributes, listeners, setNodeRef, transform, transition } = (0, sortable_1.useSortable)({ id: props.id });
    const style = {
        transform: utilities_1.CSS.Transform.toString(transform),
        transition: transition,
    };
    return (react_1.default.createElement(item_wrapper_1.ItemWrapper, { overlay: false, ref: setNodeRef, style: style, ...props, ...attributes, ...listeners }));
}
exports.SortableWrapper = SortableWrapper;
//# sourceMappingURL=sortable-wrapper.js.map